import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import './style.css';
import { useEffect, useState } from 'react';
import { httpApiGetText, httpApiPostText } from '../../../../lib';
import * as env from '../../../../env';
import MsgDialog from '../../../../components/MsgDialog';

const MsgDialogMasiva = (props: {Show: boolean, arrCodigos: any,  HandlerClickOk: any, form: any, actionOK: any, actionNOK: any, signo?: number}) => {
             
    let [clasificacion, setClasificacion] = useState(new Array());   
    let [subCalsificacion, setsubCalsificacion] = useState(new Array());       
    let [subtipo, setSubTipo] = useState("");       
    let [tipo, setTipo] = useState("");               
    const [showCuadroDialogo, setShowCuadroDialogo] = useState(false);     


    const OnSelectChange = async (evnt: any) =>{

        tipo = evnt.target.value;
        setTipo(tipo);
        // Llamado al servicio que trae los subtipos    
        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMotivos/BuscarClasifMotivo?paramClasif=${tipo}`;            
        const response = await httpApiGetText(recurso, {
        'Content-Type': 'application/json',
        'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
        'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });
        const dta = await JSON.parse(response.message);
        subCalsificacion = [...dta];
        setsubCalsificacion([...subCalsificacion]);

    }

    const HnadlerSubtipo = (evnt: any) =>{
        subtipo = evnt.target.value;
        setSubTipo(subtipo);
    }

    const hendlerAdd = async () =>{

        const bdy: any = [];

        props.arrCodigos.map(async (item: any)=>{
            const req = {
                DET_PAIS: "CL",
                DET_ANNO: props.form.Anno,
                DET_MES: props.form.Mes,
                DET_CENTRO: props.form.Centro,
                DET_ALMACEN: props.form.Almacen,
                DET_INV_ITEM_ID: item.Codigo,
                DET_ESPECIAL: item.E,
                DET_SUB_ID_MOTIVO: subtipo,
                DET_ID_CLASIFICACION: tipo,
                DET_CANTIDAD : Math.abs(item.Pend_Clasificar),
                DET_CANTIDAD_REAL: item.Pend_Clasificar               
            };  
            bdy.push(req);
            //console.log("Recibe :", item);
            //console.log("Envía  :", req);            

        });

        const recurso = `${env.REACT_APP_API_URL}/api/ClasificacionMotivos`;     
        const response = await httpApiPostText(recurso, "PUT", {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        }, bdy);

        const arrDta = await JSON.parse(response.message);   
            
        if(response.code >= 400){
            props.HandlerClickOk(); // cierra el modal
            props.actionNOK(arrDta.Message); // llama a función de error
            return;
        }

        props.HandlerClickOk(); // cierra el modal
        props.actionOK(); // llama a función que actualiza la grilla de la página principal

    }      

    useEffect(()=>{

        const init = async () =>{
            const recurso = `${env.REACT_APP_API_URL}/api/ClasifDiferenciasInventario`;     
            const response = await httpApiGetText(recurso,{
                'Content-Type': 'application/json',
                'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
                'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
            });
            const arrDta = await JSON.parse(response.message); 
            clasificacion = [...arrDta];
            setClasificacion([...clasificacion]);
        }

        init();

    }, []);    

 return (
      <div>
        <Modal show={props.Show} centered={true} size="xl" >
            <Modal.Header  className=' bg-success' >
                <Modal.Title className='h3 text-center text-light'>
                    <h3>Clasificación Masiva</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <div className=' row m-3'>
                        <div className='col col-lg-4 col-md-12'>
                            <div>Clasificación</div>
                            <div>
                                <select  value={tipo} id="tipo" className="form-select mt-3 col-md-12 col-lg-6" onChange={OnSelectChange} >
                                    <option key={-3} value={""}>Seleccione tipo</option>                                                                            
                                    {
                                        clasificacion.map((obj: any, idx:number)=> <option key={idx} value={obj.ID}>{obj.DESCRIPCION}</option>)
                                    }
                                </select >
                            </div>
                        </div>
                        <div className='col col-lg-4 col-md-12'>
                            <div>
                                Motívo
                            </div>
                            <div>
                                <select value={subtipo} id="formClasificacion" className="form-select mt-3 col-md-12 col-lg-6" onChange={HnadlerSubtipo} >
                                    <option key={-3} value={""}>Seleccione Subtipo</option>                                                                            
                                    {
                                        subCalsificacion.map((obj: any, idx:number)=> <option key={idx} value={obj.SUB_ID_MOTIVO}>{obj.SUB_DESCRIPCION}</option>)
                                    }
                                </select >
                            </div>                            
                        </div>   
                        <div className='col col-lg-4 col-md-12 d-flex align-items-end justify-content-center '>
                            <Button className='btn btn-success '  onClick={()=>setShowCuadroDialogo(true)}
                                disabled={(tipo === "") || (subtipo === "")}
                            > + Agrega clasificación
                            </Button>
                        </div>                     
                    </div>                                   
            </Modal.Body>                
            <Modal.Footer className=''>
                <Button type="button" className="btn btn-danger btnColorNOk " onClick={props.HandlerClickOk}>
                    Cerrar
                </Button>                                 
            </Modal.Footer>
        </Modal>     
            {showCuadroDialogo && <MsgDialog 
                Title="Clasificación Masiva"
                Icon="!"
                Show={showCuadroDialogo}
                BtnNokName="No, cancelar"
                BtnOkName="Si, continuar"
                Message="¿Está seguro de realizar la clasificación de todos los ítems seleccionados?"
                HandlerClickOk={hendlerAdd}
                HanlerdClickNok={()=>setShowCuadroDialogo(false)}
            /> }                             
      </div>
  );
}

export default MsgDialogMasiva;